export const HEIC_MIME_TYPES = new Set([
  "image/heic",
  "image/heif",
  "image/heic-sequence",
  "image/heif-sequence",
  "image/x-heic",
  "image/x-heif",
])

export const TIFF_MIME_TYPES = new Set([
  "image/tiff",
  "image/tif",
  "image/x-tiff",
])

export const IMAGE_MIME_TYPES = new Set([
  "image/jpg",
  "image/jpeg",
  "image/png",
  "image/webp",
  ...HEIC_MIME_TYPES,
  ...TIFF_MIME_TYPES,
])

export const ACCEPTED_IMAGE_EXTENSIONS = [
  ".jpg",
  ".jpeg",
  ".png",
  ".webp",
  ".heic",
  ".heif",
  ".tiff",
  ".tif",
] as const

// Array version of IMAGE_MIME_TYPES for compatibility with existing code
export const FILE_MIME_TYPES = Array.from(IMAGE_MIME_TYPES)

export const FILE_PDF_TYPES = ["application/pdf"]
